import {
  exportAllInboundTransport,
  exportAllInboundTransportErrors,
  exportInboundTransportRoute,
  exportInboundTransportRouteErrors,
} from "@/api/transport";
import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import { TooltipPlacement } from "antd/es/tooltip";
import { ReactNode, useState } from "react";

export default function ExportInbondTransportAction({
  children,
  route,
  year,
  onSuccess,
  placement = "bottom",
}: {
  children: ReactNode;
  route?: {
    departure_facility_id: number;
    arrival_facility_id: number;
    transport_category: string;
  };
  year?: number;
  onSuccess?: () => void;
  placement?: TooltipPlacement;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const onFinish = () => {
    onSuccess?.();
    setIsOpen(false);
  };

  return (
    <ActionsPopover
      open={isOpen}
      placement={placement}
      onOpenChange={setIsOpen}
      actions={
        <>
          {route && (
            <>
              <FileDownloader
                fileOutputName={`export-inbound-transport-${route.departure_facility_id}-${
                  route.arrival_facility_id
                }-${encodeURIComponent(route.transport_category)}.xlsx`}
                fileUrlFn={() =>
                  exportInboundTransportRoute(
                    route?.departure_facility_id,
                    route?.arrival_facility_id,
                    route?.transport_category
                  )
                }
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export all
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-inbound-transport-${year}-${route.departure_facility_id}-${
                  route.arrival_facility_id
                }-${encodeURIComponent(route.transport_category)}.xlsx`}
                fileUrlFn={() =>
                  exportInboundTransportRoute(
                    route?.departure_facility_id,
                    route?.arrival_facility_id,
                    route?.transport_category,
                    year
                  )
                }
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export {year}
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-inbound-transport-errors-${year}-${
                  route.departure_facility_id
                }-${route.arrival_facility_id}-${encodeURIComponent(
                  route.transport_category
                )}.xlsx`}
                fileUrlFn={() =>
                  exportInboundTransportRouteErrors(
                    route?.departure_facility_id,
                    route?.arrival_facility_id,
                    route?.transport_category,
                    year
                  )
                }
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export errors
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
            </>
          )}
          {!route && (
            <>
              <FileDownloader
                fileOutputName={`export-inbound-transport.xlsx`}
                fileUrlFn={() => exportAllInboundTransport({})}
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export all
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-inbound-transport-${year}.xlsx`}
                fileUrlFn={() => exportAllInboundTransport({ year })}
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export {year}
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-inbound-transport-errors-${year}.xlsx`}
                fileUrlFn={() => exportAllInboundTransportErrors({ year })}
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export errors
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
            </>
          )}
        </>
      }
    >
      {children}
    </ActionsPopover>
  );
}
